import { connect } from "react-redux";
import PropTypes from "prop-types";
import AccommodationsPricing from "./AccommodationsPricing";
import { getAccommodationsPrices } from "app/pages/Booking/bookingSelectors";

const AccommodationsPricingContainer = ({ accommodationsPrices }) => {
	return <AccommodationsPricing accommodationsPrices={accommodationsPrices} />;
};

AccommodationsPricingContainer.propTypes = {
	accommodationsPrices: PropTypes.array,
};

const mapStateToProps = state => ({
	accommodationsPrices: getAccommodationsPrices(state),
});

export default connect(mapStateToProps)(AccommodationsPricingContainer);
